/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BodyUploadVideoToS3ApiVideosUploadVideoPost
 */
export interface BodyUploadVideoToS3ApiVideosUploadVideoPost {
    /**
     * 
     * @type {string}
     * @memberof BodyUploadVideoToS3ApiVideosUploadVideoPost
     */
    awemeId: string;
    /**
     * 
     * @type {string}
     * @memberof BodyUploadVideoToS3ApiVideosUploadVideoPost
     */
    videoContent: string;
}

/**
 * Check if a given object implements the BodyUploadVideoToS3ApiVideosUploadVideoPost interface.
 */
export function instanceOfBodyUploadVideoToS3ApiVideosUploadVideoPost(value: object): value is BodyUploadVideoToS3ApiVideosUploadVideoPost {
    if (!('awemeId' in value) || value['awemeId'] === undefined) return false;
    if (!('videoContent' in value) || value['videoContent'] === undefined) return false;
    return true;
}

export function BodyUploadVideoToS3ApiVideosUploadVideoPostFromJSON(json: any): BodyUploadVideoToS3ApiVideosUploadVideoPost {
    return BodyUploadVideoToS3ApiVideosUploadVideoPostFromJSONTyped(json, false);
}

export function BodyUploadVideoToS3ApiVideosUploadVideoPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyUploadVideoToS3ApiVideosUploadVideoPost {
    if (json == null) {
        return json;
    }
    return {
        
        'awemeId': json['aweme_id'],
        'videoContent': json['video_content'],
    };
}

export function BodyUploadVideoToS3ApiVideosUploadVideoPostToJSON(json: any): BodyUploadVideoToS3ApiVideosUploadVideoPost {
    return BodyUploadVideoToS3ApiVideosUploadVideoPostToJSONTyped(json, false);
}

export function BodyUploadVideoToS3ApiVideosUploadVideoPostToJSONTyped(value?: BodyUploadVideoToS3ApiVideosUploadVideoPost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aweme_id': value['awemeId'],
        'video_content': value['videoContent'],
    };
}

